export default __webpack_public_path__ + "static/media/external-user-management-kiranshastry-solid-kiranshastry-6.b47ffaaf.png";